import { render, staticRenderFns } from "./menu-draft-element-duplicate-actions.vue?vue&type=template&id=6646a404"
import script from "./menu-draft-element-duplicate-actions.vue?vue&type=script&lang=js"
export * from "./menu-draft-element-duplicate-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports